import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconArrowUp = createIcon({
  displayName: 'IconArrowUp',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M12 4.41L19.29 11.71L20.71 10.29L12 1.59L3.28998 10.29L4.70998 11.71L12 4.41ZM11 8.24L12 7.24L13 8.24V22H11V8.24Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
